export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-photos-item.vue?vue&type=template&id=3ebfb00b&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-photos-item/lk-photos-item.vue?vue&type=template&id=3ebfb00b&
// module id = 1121
// module chunks = 0